module.exports = __webpack_public_path__ + "img/16.11213575.png";